import type { ListRecipesParams } from "../types";

const COURSES = [
  "Breakfast",
  "Lunch",
  "Dinner",
  "Dessert",
  "Snack",
  "Appetizer",
  "Side Dish",
  "Drink",
];

const CUISINES = [
  "American",
  "Chinese",
  "French",
  "Indian",
  "Italian",
  "Japanese",
  "Korean",
  "Mediterranean",
  "Mexican",
  "Thai",
  "Other",
];

interface FilterBarProps {
  params: ListRecipesParams;
  onChange: (params: ListRecipesParams) => void;
}

export default function FilterBar({ params, onChange }: FilterBarProps) {
  const hasFilters = params.course || params.cuisine || params.favorite;

  return (
    <div className="flex flex-wrap gap-3 items-center">
      <select
        value={params.course ?? ""}
        onChange={(e) =>
          onChange({ ...params, course: e.target.value || undefined })
        }
        className="text-sm border border-stone-300 rounded-full px-3 py-1.5 bg-white focus:outline-none focus:ring-2 focus:ring-herb"
      >
        <option value="">All courses</option>
        {COURSES.map((c) => (
          <option key={c} value={c}>
            {c}
          </option>
        ))}
      </select>

      <select
        value={params.cuisine ?? ""}
        onChange={(e) =>
          onChange({ ...params, cuisine: e.target.value || undefined })
        }
        className="text-sm border border-stone-300 rounded-full px-3 py-1.5 bg-white focus:outline-none focus:ring-2 focus:ring-herb"
      >
        <option value="">All cuisines</option>
        {CUISINES.map((c) => (
          <option key={c} value={c}>
            {c}
          </option>
        ))}
      </select>

      <button
        onClick={() => onChange({ ...params, favorite: !params.favorite })}
        className={`text-sm px-3 py-1.5 rounded-full border transition-colors ${
          params.favorite
            ? "bg-amber-400 border-amber-400 text-white"
            : "border-stone-300 text-stone-600 hover:border-herb bg-white"
        }`}
      >
        ★ Favorites
      </button>

      {hasFilters && (
        <button
          onClick={() => onChange({})}
          className="text-xs text-stone-400 hover:text-stone-600 underline"
        >
          Clear filters
        </button>
      )}
    </div>
  );
}
